import { FULL_SCREEN_MODE, WINDOWED_MODE } from '@/vuex/types'

const isFullScreenMode = (state) => {
  return state.currentSlideMode === FULL_SCREEN_MODE
}

const isWindowedMode = (state) => {
  return state.currentSlideMode === WINDOWED_MODE
}

const isBackstateRoute = (_state, getters) => {
  return getters['featureToggles/canUseNewUiBackStage'] || (_state.route && _state.route.name !== 'PresentationBackstage')
}

const isPresenting = (_state, getters) => {
  return (getters.isWindowedMode ||
      getters.isFullScreenMode
  ) && isBackstateRoute(_state, getters)
}

const isBackstage = (state) => {
  return state.route && state.route.name === 'PresentationBackstage'
}

const isPresentingOrBackstage = (_, getters) => {
  return getters.isPresenting || getters.isBackstage
}

const presentationHasNotes = (state) => {
  return state.presentation &&
    state.presentation.slides &&
    state.presentation.slides.some((slide) => slide.notes)
}

const isAbTestCollab = () => {
  return false
}

const isTakenOwner = (state) => {
  return state.presentation &&
    state.currentUser &&
    state.presentation.takenOverBy === state.currentUser.id
}

const isDisableWhenNotOwner = (state) => {
  return isAbTestCollab() && !isTakenOwner(state)
}

const isAbTestWorkspace = (state) => {
  return isAbTestCollab() && state.presentation.accountId
}

const isOpeningPrivateFeedback = (state) => {
  return state.isOpeningPrivateFeedback
}

const presentationId = (state) => {
  return state.presentation?.id
}

// AHA-46422 / AHA-46885: the surface the slide entrance cross-fade applies to —
// exactly where the keep-alive host mounts (mirror `PresentationEditor.vue`'s
// `canKeepAlivePreloadPlugin`), AND with the transition kill switch on. Presenting
// only, never on the share/casting or PowerPoint add-in surfaces. Used both to
// start the view transition (in the setSlideActive action) and to cancel the old
// directional slide-in in the templates — so the two stay in lockstep and an
// excluded surface keeps its original animation instead of getting a hard cut.
//
// The transition is layered ON the preload: it requires `canUsePreloadAhaSlidePlugin`
// too, so turning `canUseNextBackSlideTransition` off leaves preload fully working
// (slides just animate the original way), while turning preload off disables both.
const hasSlideEntranceFade = (state, getters) => {
  return Boolean(
    getters['featureToggles/canUsePreloadAhaSlidePlugin']
      && getters['featureToggles/canUseNextBackSlideTransition']
      && getters.isPresenting
      && !state.sharePresentation
      && !state.isEnableAddinPowerpoint,
  )
}

export default {
  isFullScreenMode,
  isWindowedMode,
  isPresenting,
  hasSlideEntranceFade,
  isBackstage,
  isPresentingOrBackstage,
  presentationHasNotes,
  isTakenOwner,
  isAbTestCollab,
  isAbTestWorkspace,
  isDisableWhenNotOwner,
  isOpeningPrivateFeedback,
  presentationId,
}
